module.exports = __webpack_public_path__ + "static/img/3业务布局-多轴运动器 (2).ef8e0e8a.png";